import actions from "./actions"
import getters from "./getters"
import mutations from "./mutations"
import { ClubTeamHighlight } from "@/models"

const state = {
  clubTeamHighlight: new ClubTeamHighlight(),
  clubTeamHighlights: [],
  clubTeamHighlightLoading: false,
  clubTeamHighlightsLoading: false,
  meta: {},
  clubTeamHighlightsLimited: [],
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
}
